import FieldSelectFields_Popover from "./components/popover/popover"
import FieldPopover from "../../popover/popover"
import FieldConfig from "../../../proto/field-config"
import {GroupedData} from "../../../../data-structures/group"
import FieldSelectFields_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldsCollection from "../../../collection/base/fields-collection"
import FieldSelectFields_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldSelectFields_Pill from "./components/pill"
import FieldSelectFields_PickerValueEmpty from "./components/picker/value-empty"
import FieldSelectFields_PickerValueNotEmpty from "./components/picker/value-not-empty"

const debug = false
// const debug = "FieldSelectFields"

export default class FieldSelectFields extends FieldPopover {


    public fieldsStructure  : GroupedData
    public fields           : FieldsCollection

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Select fields";

        this.placeholder        = _.get(config,'placeholder','None');

        this.fields             = _.get(config, 'fields', new FieldsCollection([]))
        this.fieldsStructure    = _.get(config, 'fieldsStructure', [])

        this.components.PopoverMenu         = FieldSelectFields_Popover
        this.components.FormValueNotEmpty   = FieldSelectFields_FormValueNotEmpty
        this.components.InlineValueNotEmpty = FieldSelectFields_InlineValueNotEmpty
        this.components.Pill                = FieldSelectFields_Pill
        this.components.PickerValueEmpty    = FieldSelectFields_PickerValueEmpty
        this.components.PickerValueNotEmpty = FieldSelectFields_PickerValueNotEmpty

        debug && console.log(debug, 'constructor', this)
    }

}